import React, { useEffect, useState } from "react";
import PinImage from "../../assets/images/icons/pin-white.png";

const Home = () => {
  const [about, setAboutData] = useState([]);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_BACKEND_KEY + "about");
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const responseData = await response.json();
        setAboutData(responseData.about); // Store the first object instead of array
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAboutData();
  }, []);

  return (
    <>
      <section className="hero_style__one">
        <div className="container">
          <div className="hero-content text-center">
            <h1 className="hero__title">I'm Simran</h1>
            <h2 className="hero_highlighted__text">
              Product <br /> Specialist
            </h2>
            <h4>9+ Years of UI/UX Expertise</h4>

            <a href="#about" className="mouse-icon">
              <div className="wheel"></div>
            </a>
          </div>
        </div>
      </section>
      <section
        className="intro-style-one space-y-top space-y-bottom"
        id="about"
      >
        <div className="container">
          <div className="intro-text-content">
            <div className="intro-text-content position-relative">
              <img
                src={PinImage}
                alt="pin"
                className="intro-pin d-lg-block d-none wow fadeInLeft"
                data-wow-delay="0.05s"
              />
              <p>
                Hello, I'm {" "}
                {about && about.length > 0 ? about[0].title : ""}
              </p>
              <h3>
                {about && about.length > 0
                  ? about[0].description
                  : ""}
              </h3>
            </div>
            <div className="expertise-wrap">
              <h5>My Expertise Areas:</h5>
              <ul className="skill-list">
                {about && about.length > 0
                  ? about[0].expertise.map((skills, index) => (
                      <li key={index}>{skills}</li>
                    ))
                  : ""}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
